import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWeight } from '@fortawesome/pro-solid-svg-icons/faWeight';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import React, { memo, useCallback } from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Dropdown } from 'ui-components/components/INTERNAL/dropdown';

import style from './style.module.less';
import { ScaleDropdownItems } from '../../../components/scale/scale-dropdown-items';
import { useIsReadWeightFromScaleDisabled } from '../../../hooks/scales/use-is-read-weight-from-scale-disabled';
import { useScales } from '../../../hooks/scales/use-scales';
import { FormattedMessagePropType } from '../../../prop-types/intl';

import smartFillStyle from 'ui-components/components/smartfill.module.less';

const Scale = ({
  onReadFromScale,
  className = '',
  packageCount = 1,
  buttonText,
  buttonClassName,
  buttonIconClassName,
  isSmartFillApplied = false,
}) => {
  const { scale, enabledScalesGroupedByWorkstation, onChangeScale } = useScales();

  const { isDisabled, disabledReason } = useIsReadWeightFromScaleDisabled(enabledScalesGroupedByWorkstation.length, packageCount);

  const onReadFromScaleCb = useCallback(() => onReadFromScale(scale), [onReadFromScale, scale]);

  const shouldHighlightSmartFill = isSmartFillApplied && !isDisabled;

  return (
    <div
      className={classnames(style['scale-and-dropdown'], className, {
        [smartFillStyle['smart-fill-container']]: shouldHighlightSmartFill,
      })}
    >
      <Button
        buttonTitle={disabledReason}
        className={classnames(style.scale, buttonClassName, {
          [style['smart-fill-highlighting']]: shouldHighlightSmartFill,
        })}
        disabled={isDisabled}
        onClick={onReadFromScaleCb}
        theme='unstyled'
      >
        <FontAwesomeIcon className={classnames(style.icon, buttonIconClassName)} icon={faWeight} />
        {buttonText}
      </Button>
      <Dropdown menuPosition='bottom-right'>
        <Button
          buttonTitle={disabledReason}
          className={classnames(style.selector, {
            [style['smart-fill-highlighting']]: shouldHighlightSmartFill,
          })}
          disabled={isDisabled}
          theme='unstyled'
        >
          <FontAwesomeIcon className={style.caret} icon={faCaretDown} />
        </Button>
        <div className={style.scales}>
          <ScaleDropdownItems onSelectScale={onChangeScale} scalesGroupedByWorkstation={enabledScalesGroupedByWorkstation} />
        </div>
      </Dropdown>
    </div>
  );
};

Scale.propTypes = {
  onReadFromScale: PropTypes.func.isRequired,
  className: PropTypes.string,
  packageCount: PropTypes.number,
  buttonText: PropTypes.oneOfType([PropTypes.node, FormattedMessagePropType]),
  buttonClassName: PropTypes.string,
  buttonIconClassName: PropTypes.string,
};

export default memo(Scale);
